import { useState } from 'react';
import { useDeepCompareEffect } from 'ahooks';
import ChartBubble from '@/pages/intelligence/components/ChartBubble';
import { ECHARTSCOLOR } from '@/pages/intelligence/utils/echartsConst';
import { LEGEND_BOTTOM } from '@/pages/intelligence/pages/TopCharts/_config/echarts';
import usePieChartsHoverEffect from '@intelligence/components/Chart/hooks/usePieChartsHoverEffect';
import { formatPieChartLabel } from '@intelligence/utils/echartsUtils';
import { PIE_CHART_TOOLTIP_BASE_OPTION } from '@intelligence/utils/echartsConst';

// 通用单饼图数据转换格式
/** *********
 const pieSeriesData = useMemo(() => {
  let piList: any = [];
  let sum = 0;
  tableData?.forEach((item: any, i: any) => {
    let metricNum = item.metrics ? item.metrics?.find((item: any) => item.metric == metric)?.value : 0;
    const nameStr = item?.name || item?.market || '';
    let objTemp = {
      app_id: item.market,
      name: getCountryNameByCountryCode(regionsCountries, nameStr),
      value: metricNum,
    }
    sum += metricNum;
    piList.push(objTemp);
  })
  return piList;
}, [tableData, metric]);

// 获取饼图hooks
const {
  pieOption
} = useSinglePieCharts({
  pieData: pieSeriesData,
  pieTitle: gameName,
  setChartLoading,
  chartLoading,
  chartType,
});
 * **************/

export default function useSinglePieCharts(props: any) {
  const {
    pieTitle = '',
    pieData,
    legendsCustomMade, // 图例配置信息
    labelFortmatter, // label展示formatter
    setChartLoading,
    chartType = 'pie',
    chartLoading,
    colors = ECHARTSCOLOR,
    chartsInstance,
    titleNow,
    startDate,
    endDate,
    timeText,
    secondTitleRight,
    gameHighId = '',
    pieTitleTextStyle,
    pieTitleTop,
    topChartsType,
    tooltip,
    pieLegendGap = 0,
    ifHasOtherHeadContent = false,
  } = props;

  // console.log('useSinglePieCharts', props);

  const legendsCustomMadeFun = (seriesData: any) => {
    return {
      type: 'scroll',
      orient: 'horizontal', // 横向
      pageIconColor: '#000', // 翻页箭头颜色
      selectedMode: true,
      pageIconSize: 12,
      pageTextStyle: {
        color: '#000', // 翻页数字颜色
      }, // 翻页数字设置
      show: true,
      icon: 'circle',
      itemWidth: 8,
      itemHeight: 8,
      // bottom: 0,
      bottom: LEGEND_BOTTOM,
      left: 'center',
      textStyle: {
        // 拉近文案到左侧 legend 图标间距至 4px
        padding: [0, 0, 0, -7],
        rich: {
          a: {
            color: '#888888',
            fontSize: 12,
          },
          boldB: {
            color: '#262832',
            fontSize: 12,
            fontWeight: 'bold',
          },
        },
      },
      itemGap: 20, // 图例之间间距20
      // 解决多条数据存在相同游戏名称的问题，利用唯一id来
      formatter: (name: any) => {
        const showObj = seriesData?.find((v: any) => v?.name == name) || {};
        const showId = showObj?.app_id || '';
        const showText = showObj?.name || '';
        // 高亮legend标题
        return `{${gameHighId !== '' && showId === gameHighId ? 'boldB' : 'a'}|${showText}}`;
      },
    };
  };

  const pieLabelFormatter = (params: any) => {
    // return `${params?.data?.name}:  ${params?.percent}%\n{hr|}\n`;
    // 若是高亮元素则使用高亮rich样式
    const isHigh = gameHighId === '' ? false : params?.data?.app_id == gameHighId;
    return formatPieChartLabel(params, isHigh);
  };

  const [pieOption, setPieOption] = useState<any>(null);

  usePieChartsHoverEffect({
    loading: chartLoading,
    chartType,
    chartsInstance,
    setOption: setPieOption,
  });

  useDeepCompareEffect(() => {
    if (setChartLoading && chartType === 'pie') {
      setChartLoading(false);
    }
    const legendOption = legendsCustomMade ? legendsCustomMade : legendsCustomMadeFun(pieData);
    const seriesLayoutConfig: any = {};
    if (pieLegendGap > 0) {
      seriesLayoutConfig.bottom = pieLegendGap + 20;
    }

    const pieOptionTmp = {
      // calculable: true,
      color: colors,
      // legend: legendsCustomMade ? legendsCustomMade : legendsCustomMadeFun(pieData),
      legend: {
        ...legendOption,
        itemGap: 18,
        itemWidth: 20,
        itemHeight: 10,
        itemStyle: {
          ...legendOption?.itemStyle,
          opacity: 1,
        },
      },
      title: {
        text: pieTitle,
        left: 'center',
        // top: "45%",
        top: pieTitleTop ?? '45%',
        textStyle: {
          fontWeight: 600,
          fontSize: 12,
          color: '#262832',
          width: 100,
          overflow: 'truncate',
          ...(pieTitleTextStyle || {}),
        },
      },
      tooltip: {
        ...PIE_CHART_TOOLTIP_BASE_OPTION,
        ...(tooltip || {}),
        formatter: (params: any) => {
          return ChartBubble({
            chartType,
            titleNow,
            startDate,
            endDate,
            timeText,
            data: params,
            secondTitleRight,
            topChartsType,
            ifHasOtherHeadContent,
          });
        },
        backgroundColor: 'rgba(0,0,0,0)',
      },
      series: {
        avoidLabelOverlap: true,
        type: 'pie',
        ...seriesLayoutConfig,
        // radius: ['30%', '60%'],
        radius: [55, 95],
        center: ['50%', '50%'],
        // emphasis: {
        //   itemStyle: {
        //     shadowBlur: 10,
        //     shadowOffsetX: 0,
        //     shadowColor: 'rgba(0, 0, 0, 0.5)'
        //   },
        // },
        // bottom: 20,
        // bottom: 16,
        label: {
          position: 'outside',
          alignTo: 'labelLine',
          bleedMargin: 5,
          fontSize: 12,
          color: '#262832',
          formatter: labelFortmatter ? labelFortmatter : pieLabelFormatter,
          padding: [0, -6], // 取消hr线跟延长线之间的间隙
          rich: {
            per: {
              padding: [4, 0],
              align: 'left',
              opacity: 1,
            },
            context: {
              padding: [4, 0],
              align: 'left',
              opacity: 1,
            },
            contextbold: {
              padding: [4, 0],
              align: 'left',
              opacity: 1,
              fontWeight: 'bold',
            },
            hr: {
              width: '100%',
              height: 0,
              borderWidth: 2,
              borderColor: 'auto',
              opacity: 1,
            },
            a: {
              lineHeight: 20,
              align: 'center',
              color: 'transparent',
            },
          },
          // rich: {
          //   ...getPieChartLabelBaseRich(),
          // },
        },
        labelLine: {
          // 折线弯曲程度配置
          length: 30,
          length2: 30,
          showAbove: false,
          // minTurnAngle: 80,
          maxSurfaceAngle: 80,
          lineStyle: {
            width: 2,
          },
        },
        minAngle: 10,
        data: pieData,
        itemStyle: {
          borderRadius: 5,
          borderColor: '#fff',
          borderWidth: 1,
        },
      },
      graphic: [
        {
          type: 'text',
        },
      ],
    };
    setPieOption(pieOptionTmp);
  }, [
    chartType,
    chartLoading,
    pieData,
    labelFortmatter,
    legendsCustomMade,
    pieTitle,
    titleNow,
    startDate,
    endDate,
    timeText,
    tooltip,
    pieLegendGap,
  ]);

  return {
    pieOption,
  };
}
